import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-request-sent',
  templateUrl: './request-sent.component.html',
  styleUrls: ['./request-sent.component.scss']
})
export class RequestSentComponent implements OnInit {

  constructor(
    private activeModal: NgbActiveModal) { }

  ngOnInit() {

  }

  closeDialog() {
    this.activeModal.dismiss();
  }

}
